<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/transactions'"
            >Transactions</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%"
        >
        </date-range-picker>
      </span>
      <span class="col-1">
        <button
          style="font-size: 14px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>
      <span class="col-4">
        <!-- <input
          type="text"
          class="form-control"
          placeholder="Transaction ID"
          style="padding: 10px"
        /> -->
        <select
          class="custom-select"
          v-model="account_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!account_id" :value="null" disabled selected>
            Select a Project ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="project in projects"
            :key="project.code"
            :value="project.account_id"
          >
            {{ project.code }}
            ({{ project.name }})
          </option>
        </select>
      </span>
      <span class="col-3">
        <!-- <input
          type="text"
          class="form-control"
          placeholder="Type"
          style="padding: 10px"
        /> -->
        <select
          class="custom-select"
          v-model="type"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!type" :value="null" disabled selected>
            Select a Transaction Type
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="typ in transactionTypes"
            :key="typ.name"
            :value="typ.id"
          >
            {{ typ.name }}
          </option>
        </select>
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="redirectToCreateTransaction()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">
            new Transaction
          </p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <spinner v-if="searchingTransactions" />
        <vue-good-table
          v-else
          :columns="transactionColumns"
          :rows="transactions"
          max-height="450px"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'code'">
              <router-link
                style="color: #00a5e3 !important"
                :to="
                  '/' +
                  authUser.userable_type +
                  '/projects/transaction/' +
                  props.row.code +
                  '/update/' +
                  props.row.id
                "
              >
                {{ props.formattedRow[props.column.field] }}</router-link
              >
            </span>
            <span v-else-if="props.column.label == 'Amount'">
              {{ fixNumberView(props.row.amount) }}
            </span>
            <span v-else-if="props.column.label == 'Final Amount (USD)'">
              {{ getUSDAmount(props.row) }}
            </span>
          </template></vue-good-table
        >
        <!-- <table v-else style="text-align: center">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Transaction ID</th>
              <th>Project ID</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Exchange Rate</th>
              <th>Final Amount (USD)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="text-align: center"
              v-for="(transaction, key) in transactions"
              :key="key"
            >
              <td>{{ key + 1 }}</td>
              <td>
                {{ moment(transaction.date).format("YYYY-MM-DD") }}
              </td>
              <td>
                {{ transaction.code }}
              </td>
              <td>
                {{ transaction.owner_code }}
              </td>
              <td>
                {{
                  transactionTypes.find((type) => {
                    return type.id == transaction.type;
                  }).name
                }}
              </td>
              <td>
                {{ transaction.amount }}
              </td>
              <td>
                {{ transaction.currency.code }}
              </td>
              <td>
                {{ transaction.exchange_rate }}
              </td>
              <td>
                {{
                  (transaction.amount * transaction.exchange_rate).toFixed(3)
                }}
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToUpdateTransaction(transaction)"
                  class="fa fa-edit"
                ></i>
              </td>
            </tr>
          </tbody>
        </table> -->
      </md-card>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import TransactionsFilter from "../../filters/TransactionsFilter";
import DateRangePicker from "vue2-daterange-picker";
import Spinner from "vue-simple-spinner";

export default {
  name: "projectTransactions",
  data() {
    return {
      transactionColumns: [
        {
          label: "Transaction ID",
          field: "code",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Project ID",
          field: "owner_code",
        },
        {
          label: "Type",
          field: this.transactionType,
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency.code",
        },
        {
          label: "Exchange Rate	",
          field: "exchange_rate",
        },
        {
          label: "Final Amount (USD)",
          field: this.calculateUSDAmount,
        },
      ],
      actionModalType: null,
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      transactionList: [],
      type: null,
      transaction_id: null,
      account_id: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    DateRangePicker,
    Spinner,
  },
  created: function () {
    this.$store.dispatch("searchProjects");
    var transactionsFilter = TransactionsFilter();
    transactionsFilter.account_types = ["project_account"];
    this.$store
      .dispatch("searchTransactions", {
        filter: transactionsFilter,
        resultMode: "default",
      })
      .then(() => {
        this.transactionList = this.transactions;
      });
  },

  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      transactions: (state) =>
        state.transactionStore.transactionSearch.transactions,
      projects: (state) => state.projectStore.projectSearch.projects,
      searchingTransactions: (state) =>
        state.transactionStore.transactionSearch.searchingTransactions,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    init() {
      this.selectedTransactionId = null;
      this.actionModalType = null;
      this.showTransactionModal = false;
      this.$store.dispatch("searchTransaction").then(() => {
        this.filterTransactions();
      });
    },
    transactionType(transaction) {
      return (
        transaction.type.charAt(0).toUpperCase() + transaction.type.slice(1)
      );
    },
    calculateUSDAmount(transaction) {
      return transaction.amount * transaction.exchange_rate;
    },
    getUSDAmount(transaction) {
      var amount = this.calculateUSDAmount(transaction);
      return this.fixNumberView(amount);
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    redirectToCreateTransaction() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/projects/transactions/create"
      );
    },
    redirectToUpdateTransaction(transaction) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/projects/transaction/" +
          transaction.code +
          "/update/" +
          transaction.id
      );
    },
    filter() {
      var transactionsFilter = TransactionsFilter();
      transactionsFilter.text = this.keyword;
      if (this.transaction_id) {
        transactionsFilter.ids = [this.transaction_id];
      }
      if (this.account_id) {
        transactionsFilter.account_ids = [this.account_id];
      }
      if (this.type) {
        transactionsFilter.types = [this.type];
      }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        transactionsFilter.dateRange = date_range;
      }
      transactionsFilter.account_types = ["project_account"];
      this.$store.dispatch("searchTransactions", {
        filter: transactionsFilter,
        resultMode: "default",
      });
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    // deleteTransaction(id) {
    //   sweetAlert({
    //     title: "Confirmation",
    //     text: "Are you sure you want to delete this transaction?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes",
    //     cancelButtonText: "No",
    //   }).then((result) => {
    //     /* Read more about isConfirmed, isDenied below */
    //     if(result.value) {
    //       this.$store.dispatch("deleteTransaction", id);
    //     }
    //   });
    // },
  },
  watch: {},
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.custom-select {
  background-color: #fafaf7;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}


/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/projectsTransactions.vue